import { DisclosureSection } from '@components/core-ui/DisclosureSection';
import { useState } from 'react';
import { BillingAccount } from '../BillingAccountCard';
import { Wrapper } from './styles/Wrapper';

export const BillingAccountList = () => {
  const [billingAccountsDisclosureOpen, setBillingAccountsDisclosureOpen] = useState<boolean>(true);

  const billingAccountSectionTitle = 'Organization Billing Account';

  return (
    <Wrapper className="flex flex-col">
      <div>
        <DisclosureSection
          title={billingAccountSectionTitle}
          open={billingAccountsDisclosureOpen}
          setOpenState={setBillingAccountsDisclosureOpen}
          loading={false}
        >
          <BillingAccount />
        </DisclosureSection>
      </div>
    </Wrapper>
  );
};
